import fm from "front-matter"
import { meta } from "./util"

type Matter = {
  title: string
  description: string
  slug: string
  lead: string
}

type Story = Matter & {
  content: string
}

let storiesBySlug: Record<string, Story> | undefined

const getStoriesBySlug = (): Record<string, Story> => {
  storiesBySlug ??= Object.fromEntries(
    Object.values(
      import.meta.glob<string>("./stories/*.md", {
        query: "?raw",
        import: "default",
        eager: true,
      }),
    )
      .map((md) => fm<Matter>(md))
      .map(({ attributes, body: content }) => ({ ...attributes, content }))
      .map((story) => [story.slug, story]),
  )

  return storiesBySlug
}

export const hasStories = () => !!Object.keys(getStoriesBySlug()).length

export const getStories = (): Story[] => Object.values(getStoriesBySlug())

export const getStory = (slug: string) => getStoriesBySlug()[slug]

export const getStoryMeta = (slug: string) => {
  const story = getStory(slug)

  return meta({
    title: story?.title,
    description: story?.description,
  })
}
